import { createFileRoute } from '@tanstack/react-router';

import { SafetyOverviewPage } from '@/features/safety/overview-page';

export const Route = createFileRoute('/_app/projects/$projectId/safety/overview')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <SafetyOverviewPage projectId={projectId} />;
}
